import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { useStateValue } from '../state'
import { client } from '../../utils'
import { adaExceptions as endpoints } from '../../api_urls'
import ButterToast, { Cinnamon } from 'butter-toast'

const ExceptionDeleteModal = props => {
  const [currentState, dispatch] = useStateValue()
  const [isLoading, setIsLoading] = useState(false)

  const deleteException = () => {
    setIsLoading(true)
    const data = {
      ruleId: currentState.selectedForDelete,
      studentId: props.studentId,
    }
    client
      .post(endpoints.deleteException(), data)
      .then(resp => {
        dispatch({
          type: 'updateAggregatedRules',
          aggregatedRules: resp.data.aggregatedRules,
        })
        props.toggle(false)
        setTimeout(() => {
          setIsLoading(false)
        }, 200)
      })
      .catch(err => {
        setIsLoading(false)
        props.toggle(false)
        ButterToast.raise({
          content: (
            <Cinnamon.Crunch
              title="Error"
              content={`There was an error trying to delete an exception. ${err}`}
              scheme={Cinnamon.Crisp.SCHEME_RED}
              icon={<i className="far fa-exclamation-triangle fa-3x" />}
            />
          ),
        })
      })
  }

  return (
    <Modal
      show={props.show}
      onHide={() => props.toggle(!props.show)}
      className="modal-center"
    >
      <Modal.Header>
        <Modal.Title>Delete Exception</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <div className="d-flex justify-content-center">
            <div
              className="icon icon_spinner10 icon_spin2 spinner LoadingSpinner d-flex justify-content-center mb-4"
              style={{ fontSize: '26pt', color: '#8b0000' }}
            />
          </div>
        ) : (
          <div>
            <div>Are you sure you want to delete this exception?</div>
            <div className="font-weight-bold mt-4 mb-4">
              It cannot be undone.
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => {
            props.toggle(false)
          }}
          className="btn btn-myed btn-default btn-default-myed ml-2 pull-right"
        >
          Cancel
        </button>
        <button
          onClick={() => {
            deleteException()
          }}
          className="btn btn-danger pull-right"
        >
          Delete
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default ExceptionDeleteModal

ExceptionDeleteModal.propTypes = {
  studentId: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}
